module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-23-172c29710f8ae1b114f616be7e1b05d1.svg";